import { render, staticRenderFns } from "./ConfirmOrderModal.vue?vue&type=template&id=a40dfd56&scoped=true"
import script from "./ConfirmOrderModal.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOrderModal.vue?vue&type=style&index=0&id=a40dfd56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40dfd56",
  null
  
)

export default component.exports